import { FETCH_REPORT_FS_NOTES_REQUEST, FETCH_REPORT_FS_NOTES_SUCCESS, FETCH_REPORT_FS_NOTES_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const reportFSNotesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPORT_FS_NOTES_REQUEST:
            return { ...state, loading: true };
        case FETCH_REPORT_FS_NOTES_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_REPORT_FS_NOTES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reportFSNotesReducer;
